if (!customElements.get('slynara-image-comparison')) {
  customElements.define(
    'slynara-image-comparison',
    class SlynaraImageComparison extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('[data-slynara-comparison-range]');
        if (!this.range) return;

        this.update = () => {
          const position = Math.min(100, Math.max(0, Number(this.range.value) || 0));
          this.style.setProperty('--comparison-position', `${position}%`);
          this.range.setAttribute('aria-valuetext', `${position}% with Slynara revealed`);
        };

        this.range.addEventListener('input', this.update);
        this.update();
      }

      disconnectedCallback() {
        this.range?.removeEventListener('input', this.update);
      }
    }
  );
}
